import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { config } from "../../services/configHeader";
const user = JSON.parse(localStorage.getItem("user_data")) || {}
// const userId = user?.user_id;
const accountType = user?.account_type;
const baseUrl = process.env.REACT_APP_BASE_URI;

const normalizeThunkError = (error, fallbackMessage = "Request failed") => ({
  status: error?.response?.status || error?.status || 500,
  response: {
    data: {
      ...(error?.response?.data || {}),
      message:
        error?.response?.data?.message ||
        error?.message ||
        fallbackMessage,
      data: error?.response?.data?.data || null,
    },
  },
  message: error?.message || fallbackMessage,
});

let initialState = {
  holyLoading: false,
  holySuccess: false,
  holyError: false,
  holyMessage: null,

  holyGetLoading: false,
  holyGetSuccess: false,
  holyGetError: false,
  holyGetMessage: null,
  holyGetData: null,

  fetchHolyLoading: false,
  fetchHolySuccess: false,
  fetchHolyError: false,
  fetchHolyMessage: null,
  fetchHolyData: null,
};

export const fetchData = createAsyncThunk("fetchData", async (userId) => {
  return await axios
    .get(`${baseUrl}admin/getMyHolidayList?userId=${userId}`, config)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (!navigator.onLine) {
        let data = {
          response: {
            data: [],
            message: "No Internet Connection Found",
            success: false,
          },
          data: {
            data: [],
            message: "No Internet Connection Found",
            success: false,
          },
        };
        return data;
      } else {
        return normalizeThunkError(error);
      }
    });
});

export const fetchHolidayData = createAsyncThunk("fetchHolidayData", async (path) => {
  return await axios
    .get(`${baseUrl}${path}`, config)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (!navigator.onLine) {
        let data = {
          response: {
            data: [],
            message: "No Internet Connection Found",
            success: false,
          },
          data: {
            data: [],
            message: "No Internet Connection Found",
            success: false,
          },
        };
        return data;
      } else {
        return normalizeThunkError(error);
      }
    });
});

export const saveHoliday = createAsyncThunk("saveHoliday", async (data) => {
  const result = {
    data: {
      message: "Sorry, you can only view the data, not create it.",
      data: [],
    },
  };
  return parseInt(accountType) === 2
    ? result
    : await axios
      .post(`${baseUrl}admin/createMyHoliday`, data, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
      if (!navigator.onLine) {
        let data = {
          response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
        };
        return data;
      } else {
        return normalizeThunkError(error);
      }
    });
});

const holidaySlice = createSlice({
  name: "holiday",
  initialState,

  reducers: {

    initFetchHolidayState: (state) => {
      state.fetchHolyLoading = false;
      state.fetchHolySuccess = false;
      state.fetchHolyError = false;
      state.fetchHolyMessage = null;
      state.fetchHolyData = null;
    }

  },

  extraReducers: (builder) => {
    builder.addCase(fetchData.pending, (state, action) => {
      state.holyGetLoading = true;
      state.holyGetSuccess = false;
      state.holyGetError = false;
      state.holyGetMessage = null;
      state.holyGetData = null;
    });
    builder.addCase(fetchData.fulfilled, (state, action) => {
      const payload = action.payload || {};
      const body = payload.data || {};
      const responseBody = payload.response?.data || {};
      const isSuccess = payload.status == 200 || payload.status == "200";

      state.holyGetLoading = false;
      state.holyGetSuccess = isSuccess;
      state.holyGetError = !isSuccess;
      state.holyGetMessage = isSuccess
        ? body.message || body.msg || null
        : responseBody.message || body.message || body.msg || "Request failed";
      state.holyGetData = isSuccess
        ? body.data || []
        : responseBody.data || [];
    });
    builder.addCase(fetchData.rejected, (state, action) => {
      state.holyGetLoading = false;
      state.holyGetSuccess = false;
      state.holyGetError = true;
      state.holyGetMessage = action.payload?.response?.data?.message || action.error?.message || "Request failed";
      state.holyGetData = null;
    });
    // To create holiday ------------------------------------
    builder.addCase(saveHoliday.pending, (state, action) => {
      state.holyLoading = true;
      state.holySuccess = false;
      state.holyError = false;
      state.holyMessage = null;
    });
    builder.addCase(saveHoliday.fulfilled, (state, action) => {
      const payload = action.payload || {};
      const body = payload.data || {};
      const responseBody = payload.response?.data || {};
      const isSuccess = payload.status == 200 || payload.status == 201 || payload.status == "200" || payload.status == "201";

      state.holyLoading = false;
      state.holySuccess = isSuccess && accountType != 2;
      state.holyError = !isSuccess || accountType == 2;
      state.holyMessage = isSuccess
        ? body.message || body.msg || null
        : responseBody.message || body.message || body.msg || "Request failed";
    });
    builder.addCase(saveHoliday.rejected, (state, action) => {
      state.holyLoading = false;
      state.holySuccess = false;
      state.holyError = true;
      state.holyMessage = action.payload?.response?.data?.message || action.error?.message || "Request failed";
    });
    // ----------------------------------------------------------
    // -----------------------------------------

    builder.addCase(fetchHolidayData.pending, (state, action) => {
      state.fetchHolyLoading = true;
      state.fetchHolySuccess = false;
      state.fetchHolyError = false;
      state.fetchHolyMessage = null;
      state.fetchHolyData = null;
    });

    builder.addCase(fetchHolidayData.fulfilled, (state, action) => {
      const payload = action.payload || {};
      const body = payload.data || {};
      const responseBody = payload.response?.data || {};
      const status = payload.status;
      if (status == 200 || status == "200") {
        if (
          body.status == true ||
          body.status == "true" ||
          body.code == 200 ||
          body.code == "200"
        ) {
          state.fetchHolyLoading = false;
          state.fetchHolySuccess = true;
          state.fetchHolyError = false;
          state.fetchHolyMessage = body.message || body.msg || null;
          state.fetchHolyData = body.data || null;
        } else {
          state.fetchHolyLoading = false;
          state.fetchHolySuccess = false;
          state.fetchHolyError = true;
          state.fetchHolyMessage =
            body.message || body.msg || "Request failed";
          state.fetchHolyData = null;
        }
      } else {
        state.fetchHolyLoading = false;
        state.fetchHolySuccess = false;
        state.fetchHolyError = true;
        state.fetchHolyMessage =
          responseBody.message || body.message || body.msg || "Request failed";
        state.fetchHolyData = responseBody.data || null;
      }
    });

    builder.addCase(fetchHolidayData.rejected, (state, action) => {
      state.fetchHolyLoading = false;
      state.fetchHolySuccess = true;
      state.fetchHolyError = false;
      state.fetchHolyMessage = null;
      state.fetchHolyData = null;
    });
  },
});
export const { initFetchHolidayState } = holidaySlice.actions;

export default holidaySlice.reducer;
